/* tslint:disable */
/* eslint-disable */
/**
 * Products API
 * API for managing products
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GenericLinkPlateformesCommand
 */
export interface GenericLinkPlateformesCommand {
    /**
     * 
     * @type {Array<string>}
     * @memberof GenericLinkPlateformesCommand
     */
    plateformeIds: Array<string>;
}

/**
 * Check if a given object implements the GenericLinkPlateformesCommand interface.
 */
export function instanceOfGenericLinkPlateformesCommand(value: object): value is GenericLinkPlateformesCommand {
    if (!('plateformeIds' in value) || value['plateformeIds'] === undefined) return false;
    return true;
}

export function GenericLinkPlateformesCommandFromJSON(json: any): GenericLinkPlateformesCommand {
    return GenericLinkPlateformesCommandFromJSONTyped(json, false);
}

export function GenericLinkPlateformesCommandFromJSONTyped(json: any, ignoreDiscriminator: boolean): GenericLinkPlateformesCommand {
    if (json == null) {
        return json;
    }
    return {
        
        'plateformeIds': json['plateformeIds'],
    };
}

export function GenericLinkPlateformesCommandToJSON(json: any): GenericLinkPlateformesCommand {
    return GenericLinkPlateformesCommandToJSONTyped(json, false);
}

export function GenericLinkPlateformesCommandToJSONTyped(value?: GenericLinkPlateformesCommand | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'plateformeIds': value['plateformeIds'],
    };
}

